import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useSlackIsConnected(tenant: number) {
  return useQuery<boolean>({
    queryKey: ['slack', tenant],
    queryFn: async () => {
      const { data } = await axios.get(
        `${getBongoUrl()}/v1/org/${tenant}/integrations/slack`
      );

      return !!data?._id;
    },
  });
}
